import axios from '@/libs/api.request'

export const InvoiceList = (data) => {
  return axios.request({
    url: '/print/invoice/list',
    params: data,
    method: 'get'
  })
}

export const UploadInvoice = (data) => {
  return axios.request({
    url: '/print/invoice/upload',
    data: data,
    method: 'post'
  })
}
export const SendEmail = (data) => {
  return axios.request({
    url: '/print/invoice/send',
    params: data,
    method: 'get'
  })
}
export const CreateInvoice = (data) => {
  return axios.request({
    url: '/print/invoice/create',
    data,
    method: 'put'
  })
}
